/*
 * -----------------------------------------------------------------------
 *  <copyright file="setting-menu.interface.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2022 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { IExpandableGridColumnV2 } from '../../expandable/grid-v2/interfaces-v2/grid-props-v2.interface';

export interface SettingsMenuProps {
    columns: IExpandableGridColumnV2[];
    gridKey: string;
    onColumnsSubmit: (items: IExpandableGridColumnV2[]) => void;
    removeHideFilter?: boolean;
    group: IExpandableGridColumnV2[];
    setGroup: (items: IExpandableGridColumnV2[]) => void;
    showPager: boolean;
    pageSize: number;
    setCurrentPage: (number: number) => void;
    handleChangePageSize: (value: number, triggerCallback?: boolean) => void;
    disabled: boolean;
}

export enum SettingsMenuTypes {
    lock = 'locked',
    show = 'show',
    group = 'grouped',
}
